<template>
  <div style="width: 100%; text-align:right;">
    <v-layout row wrap style="padding: 10px;">
      <v-flex xs4>
        <span style="float: right;padding-left: 10px;">סינון שלב התקדמות</span>
        <span class="custom-dropdown custom-dropdown--white" style="float: right;">
          <select v-model="selectedStatus" class="custom-dropdown__select custom-dropdown__select--white">
            <option value="">הצג הכל</option>
            <option v-for="status in statuses" :value="status['.key']">{{status.Name}}</option>
          </select>
        </span>
      </v-flex>
      <v-flex xs4>
        <span style="float: right;padding-left: 10px;">עדכון אחרון לפני</span>
        <span class="custom-dropdown custom-dropdown--white" style="float: right;">
          <select v-model="selectedLastUpdate" class="custom-dropdown__select custom-dropdown__select--white">
            <option value="">הצג הכל</option>
            <option v-for="update in updatesList" :value="update.Value">{{update.Text}}</option>
          </select>
        </span>
      </v-flex>
      <v-flex xs2>
        &nbsp;
      </v-flex>
      <v-flex xs2>
        <v-icon class="btnIcon mr-2 ml-2 left" v-tooltip:bottom="{ html: 'הדפסה' }">print</v-icon>
        <v-icon class="btnIcon mr-2 ml-2 left" v-tooltip:bottom="{ html: 'ייצוא אקסל' }">file_download</v-icon>
      </v-flex>
    </v-layout>
    <table class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable" style="padding: 20px!important; border:none; width: 100%;">
      <tr class="trPrint trHeader">
        <th class="tdData sp">שם פרויקט</th>
        <th class="tdData">כתובת</th>
        <th class="tdData">ישוב</th>
        <th class="tdData">שלב התקדמות</th>
        <th class="tdData">תאריך יצירה</th>
        <th class="tdData">תאריך עדכון</th>
      </tr>
    </table>
    <div class="scrollContent" v-if="hasData">
      <table class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1" style="border:none;">
        <tr v-for="row in filteredRows" :class="{ 'trSelect': row.selected }">
          <td class="tdData tdTxt  sp">{{row.Name}}</td>
          <td class="tdData tdTxt">{{row.Address}}</td>
          <td class="tdData tdTxt">{{row.City}}</td>
          <td class="tdData tdTxt">
            <div class="divColorIcon" :style="{ 'background-color': getStatusColor(row.StatusKey) }"></div>
            <div style="line-height: 30px;">{{getStatusName(row.StatusKey)}}</div>
          </td>
          <td class="tdData tdTxt">{{row.CreateDate}}</td>
          <td class="tdData tdTxt">{{row.UpdateDate}}</td>
        </tr>
      </table>
    </div>
    <div fluid v-else>
      <h3 style="padding-top: 40px;text-align:center;">אין נתונים</h3>
    </div>
  </div>
</template>

<script>
  import { db } from '../firebase';
  var projectsRef = db.ref('Projects');
  var statusesRef = db.ref('Statuses');

  export default {
    name: 'ReportProjects',
    data() {
      return {
        selectedStatus: '',
        selectedLastUpdate: '',
        updatesList: [
          { Value: 30, Text: '30 ימים' },
          { Value: 60, Text: '60 ימים' },
          { Value: 90, Text: '90 ימים' },
          { Value: 180, Text: '6 חודשים' },
          { Value: 365, Text: '12 חודשים' },
        ],
      }
    },
    firebase: function () {
      var vm = this;
      return {
        projects: projectsRef.orderByKey(),
        statuses: statusesRef.orderByKey()
      }
    },
    computed: {
      hasData() {
        return this.filteredRows != null && this.filteredRows != undefined && this.filteredRows.length > 0;
      },
      filteredRows() {
        var vm = this;
        var result = [];
        var today = this.$moment();
        //var updateDate = this.$moment(row.UpdateDate, 'DD/MM/YYYY');
        //duration = this.$moment.duration(today.diff(updateDate));
        //var daysProject = duration.asDays();

        if (vm.selectedStatus != "") {
          if (vm.selectedLastUpdate != "") {
            result = vm.projects.filter(function (row) {
              if (row.StatusKey == vm.selectedStatus){
                var updateDate = vm.$moment(row.UpdateDate, 'DD/MM/YYYY');
                var duration = vm.$moment.duration(today.diff(updateDate));
                var days = duration.asDays();
                return (days >= vm.selectedLastUpdate);
              }
              else {
                return false;
              }
            });
          }
          else {
            result = vm.projects.filter(function (row) {
              return row.StatusKey == vm.selectedStatus;
            });
          }
        }
        else {
          if (vm.selectedLastUpdate != "") {
            result = vm.projects.filter(function (row) {
              var updateDate = vm.$moment(row.UpdateDate, 'DD/MM/YYYY');
              var duration = vm.$moment.duration(today.diff(updateDate));
              var days = duration.asDays();
              //alert(days);
              return (days >= vm.selectedLastUpdate);
            });
          }
          else {
            result = vm.projects;
          }
        }

        return result;
      }
    },
    created() {
      this.$Log("Vue [ReportProjects] is created ...");
    },
    ready() {
      this.$Log("Vue [ReportProjects] is ready ...");
    },
    mounted() {
      this.$Log("Vue [ReportProjects] is mounted ...");
    },
    updated() {
      this.$Log("Vue [ReportProjects] is updated ...");
    },
    methods: {
      getStatusColor(statusKey) {
        var selectedColor = '#F7941D';
        for (var i = 0; i < this.statuses.length; i++) {
          if (this.statuses[i]['.key'] == statusKey) {
            selectedColor = this.statuses[i].Color;
            break;
          }
        }
        return selectedColor;
      },
      getStatusName(statusKey) {
        var selectedName = '';
        for (var i = 0; i < this.statuses.length; i++) {
          if (this.statuses[i]['.key'] == statusKey) {
            selectedName = this.statuses[i].Name;
            break;
          }
        }
        return selectedName;
      },
    }
  }

</script>
<style>
</style>



// WEBPACK FOOTER //
// ReportProjects.vue?6d25a63c